import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from './LanguageProvider';
import translations from '../translations';

function SocialIcon({ type, href }) {
  if (type === 'linkedin') {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer"
        className="social-icon-linkedin w-10 h-10 rounded-xl flex items-center justify-center dark:bg-white/[0.06] bg-slate-100 border dark:border-white/10 border-slate-200 transition-all duration-300 hover:scale-110"
        aria-label="LinkedIn">
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
        </svg>
      </a>
    );
  }
  if (type === 'instagram') {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer"
        className="social-icon-instagram w-10 h-10 rounded-xl flex items-center justify-center dark:bg-white/[0.06] bg-slate-100 border dark:border-white/10 border-slate-200 transition-all duration-300 hover:scale-110"
        aria-label="Instagram">
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
        </svg>
      </a>
    );
  }
  return null;
}

export default function Footer() {
  const { lang } = useLang();
  const t = translations[lang].footer;

  return (
    <footer id="footer" className="border-t dark:border-white/10 border-slate-200 dark:bg-slate-950/50 bg-slate-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4 group logo-hover-glow">
              <img
                src="/assets/whowsell-logo.png"
                alt="WhowSell Logo"
                className="h-10 sm:h-12 lg:h-14 w-auto object-contain drop-shadow-[0_0_4px_rgba(6,182,212,0.2)] group-hover:drop-shadow-[0_0_14px_rgba(6,182,212,0.6)]"
                draggable="false"
                loading="lazy"
                onContextMenu={(e) => e.preventDefault()}
              />
              <span className="text-xl sm:text-2xl font-bold tracking-tight dark:text-white text-slate-800 group-hover:dark:text-cyan-400 group-hover:text-cyan-600">
                WhowSell
              </span>
            </Link>
            <p className="text-sm dark:text-white/50 text-slate-500 leading-relaxed max-w-sm mb-6">
              {t.desc}
            </p>
            <div className="flex gap-3">
              <SocialIcon type="linkedin" href="https://linkedin.com/company/whowsell" />
              <SocialIcon type="instagram" href="https://instagram.com/whowsell" />
            </div>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-sm font-bold dark:text-white text-slate-900 mb-4">{t.products}</h3>
            <ul className="space-y-3">
              {/* WhowSell Cloud EN ÜSTTE: dört ürünün tek çatısı olduğu için
                  listenin girişi o. Kardeş projelerin dördünde de kendi alan
                  adı YOK, site içi `/whowsell-cloud` sayfasına gidiyor;
                  burada da öyle — dış bağlantı değil `Link`. */}
              <li>
                <Link to="/whowsell-cloud" className="text-sm dark:text-white/50 text-slate-500 hover:dark:text-white hover:text-slate-900 transition-colors">
                  {t.cloudLink}
                </Link>
              </li>
              <li>
                <a href="https://crm.whowsell.com/" target="_blank" rel="noopener noreferrer" className="text-sm dark:text-white/50 text-slate-500 hover:dark:text-white hover:text-slate-900 transition-colors">
                  {t.crmLink}
                </a>
              </li>
              {/* Burada eskiden "WhowSell App (yakında)" için bulanık bir
                  iskelet çubuk vardı: bağlantı değildi, `aria-hidden` idi,
                  ekran okuyucuda tamamen boş bir madde olarak geçiyordu.
                  App diye bir ürün yok; yerini CANLI olan Radar aldı. */}
              <li>
                <a href="https://radar.whowsell.com/" target="_blank" rel="noopener noreferrer" className="text-sm dark:text-white/50 text-slate-500 hover:dark:text-white hover:text-slate-900 transition-colors">
                  {t.radarLink}
                </a>
              </li>
              <li>
                <a href="https://ai.whowsell.com/" target="_blank" rel="noopener noreferrer" className="text-sm dark:text-white/50 text-slate-500 hover:dark:text-white hover:text-slate-900 transition-colors">
                  {t.aiLink}
                </a>
              </li>
              <li>
                <a href="https://server.whowsell.com/" target="_blank" rel="noopener noreferrer" className="text-sm dark:text-white/50 text-slate-500 hover:dark:text-white hover:text-slate-900 transition-colors">
                  {t.serverLink}
                </a>
              </li>
            </ul>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-sm font-bold dark:text-white text-slate-900 mb-4">{t.links}</h3>
            {/* Bağlantılar sütunu. Hukuki belgelerin dördü de burada
                listelenir: bir belgeye "sitenin her sayfasından sürekli
                erişilebilir" demek, altbilgide bağlantısının bulunması
                demektir — metinlerdeki kabul beyanı buna dayanıyor.
                `break-words`: en dar ekranda "KVKK Aydınlatma Metni" ve
                destek adresi sütundan taşmasın. */}
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm dark:text-white/50 text-slate-500 hover:dark:text-white hover:text-slate-900 transition-colors break-words">
                  {t.about}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm dark:text-white/50 text-slate-500 hover:dark:text-white hover:text-slate-900 transition-colors break-words">
                  {t.contactPage}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm dark:text-white/50 text-slate-500 hover:dark:text-white hover:text-slate-900 transition-colors break-words">
                  {t.privacy}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm dark:text-white/50 text-slate-500 hover:dark:text-white hover:text-slate-900 transition-colors break-words">
                  {t.terms}
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-sm dark:text-white/50 text-slate-500 hover:dark:text-white hover:text-slate-900 transition-colors break-words">
                  {t.cookies}
                </Link>
              </li>
              <li>
                <Link to="/data-protection" className="text-sm dark:text-white/50 text-slate-500 hover:dark:text-white hover:text-slate-900 transition-colors break-words">
                  {t.dataProtection}
                </Link>
              </li>
              <li>
                <a href="mailto:support@whowsell.com" className="text-sm dark:text-white/50 text-slate-500 hover:dark:text-white hover:text-slate-900 transition-colors break-words">
                  support@whowsell.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t dark:border-white/10 border-slate-200 text-center">
          <p className="text-xs dark:text-white/30 text-slate-400">{t.rights}</p>
        </div>
      </div>
    </footer>
  );
}
